import AdminUsersPage from './AdminUsersPage';

export default function AdminStudents() {
  return <AdminUsersPage userType="student" />;
}
